// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Viewmodels
import { CountryVm } from 'app/_mapper/country.vm';
import { RelationshipVm } from 'app/_mapper/relationship.vm';
import { GenderVm } from './gender.vm';

export class ContactPersonVm {
    @AutoMap() cpeAddress: string;
    @AutoMap() cpeCity: string;
    @AutoMap() cpeCountry: CountryVm;
    @AutoMap() cpeEmail: string;
    @AutoMap() cpeFirstName: string;
    @AutoMap() cpeGender: GenderVm;
    @AutoMap() cpeLastName: string;
    @AutoMap() cpeMaidenName: string;
    @AutoMap() cpePhoneNumber: string;
    @AutoMap(() => RelationshipVm) cpeRelationship: RelationshipVm = new RelationshipVm();
    @AutoMap() cpeRemarks: string;
}
